import { buildExcelColumns, setExportExcelDefaultColWidths } from '@/pages/dashboard/utils/utils';
import { formatNumberByComma } from '@/pages/datalab/utils/utils';
import { isWindow } from '@/pages/dashboard/utils/system';
import moment from 'moment';
import {
  getDownloadRawCellValue,
  getDownloadRowCell,
} from '@/pages/datalab/utils/enrichPercentAxisChartDownloadData';

export const handleDownload = (propTableOption: any, title: any) => {
  const name = (propTableOption.downloadTitle ?? title)?.replace(/\u0020/g, '_');
  const excelColumn = buildExcelColumns(propTableOption?.option?.length ?? 0);

  const defaultStyleAlign = {
    // 单元格垂直、水平居中
    alignment: {
      vertical: 'center',
      horizontal: 'center',
    },
  };

  const defaultStyleFont = {
    font: {
      sz: 11,
      name: isWindow() ? '微软雅黑' : '苹方-简', // window操作系统的字体用微软雅黑,苹果操作系统的字体用苹方
    },
  };

  const defaultStyleBorder = {
    border: {
      top: {
        style: 'thin',
      },
      bottom: {
        style: 'thin',
      },
      left: {
        style: 'thin',
      },
      right: {
        style: 'thin',
      },
    },
  };

  const headDefaultStyle = {
    ...defaultStyleAlign,
    ...defaultStyleBorder,
    font: {
      sz: 11,
      name: isWindow() ? '微软雅黑' : '苹方-简',
      bold: true,
      color: {
        rgb: 'FFFFFF', // 白色
      },
    },
    fill: {
      fgColor: { rgb: '212C53' },
    },
  };

  // 表头行
  const headerRow: any = {};

  const excelData: any = [];
  propTableOption?.option?.forEach((item, index) => {
    headerRow[excelColumn[index]] = {
      v: item.header,
      s: headDefaultStyle,
    };
  });
  excelData.push(headerRow);

  propTableOption?.downloadData?.forEach((item) => {
    const itemData: any = {};
    propTableOption?.option?.forEach((opt, index) => {
      const rawCell = getDownloadRowCell(item, opt.key);
      const resolvedValue = getDownloadRawCellValue(rawCell);
      const config: any = {
        v:
          resolvedValue === null
          || resolvedValue === undefined
          || resolvedValue === ''
            ? '-'
            : resolvedValue,
        t: 's',
        s: { ...defaultStyleAlign, ...defaultStyleFont, ...defaultStyleBorder },
      };
      switch (opt?.type) {
        case 'number': {
          config.z = '##,##0';
          config.t = 'n';
          break;
        }
        case 'float': {
          // 千分隔符 record.accuracy 小数位数 (后端已返回小数位数符合record.accuracy的数据)
          config.z = '##,##0';
          const length = 7 + (Number(opt.accuracy) || 0);
          length > 7 && (config.z = `${config.z}.`.padEnd(length, '0'));
          config.t = 'n';
          break;
        }
        case 'string': {
          // 后端可能对指标列标 string，但 table_data 仍给 number；
          // `v?.includes` 对 number 仍会调用 includes 并抛 TypeError。
          if (
            typeof config.v === 'string'
            && config.v.includes('对比项')
            && propTableOption.isEn
          ) {
            config.v = config.v === '对比项一' ? 'Compare1' : 'Compare2';
          }
          break;
        }
        case 'percent': {
          config.t = 's';
          break;
        }
        // case 'date':
        // default:;
      }
  
      itemData[excelColumn[index]] = config;
    });
    excelData.push(itemData);
  });
  // 导出excel
  exportExcelOfDatalab(name, excelData);
};

export const exportExcelOfDatalab = async (fileName: string, table: never[] | undefined, colWidth = []) => {
  fileName = fileName?.replace(/\u0020/g, '_');

  // 创建book
  const XLSX = await import('xlsx-js-style');
  const wb = XLSX.utils.book_new();
  // json转sheet
  const ws = XLSX.utils.json_to_sheet(table, { header: [], skipHeader: true });
  if (colWidth && colWidth.length > 0) {
    ws['!cols'] = colWidth;
  } else {
    setExportExcelDefaultColWidths(ws, table);
  }
  // 下载时操作系统不允许输入半角冒号，所以用全角的代替
  const timestamp = moment().format('YYYY_MM_DD HH_mm_ss');

  // sheet写入book
  XLSX.utils.book_append_sheet(wb, ws, 'file');
  // 输出
  XLSX.writeFile(wb, fileName ? `${fileName} ${timestamp}.xlsx` : `${timestamp}.xlsx`);
};

// 下载通用方法封装；前提是后端数据格式一致
const customDashboatdDownload = (tableData: any, name: string, isEn: boolean) => {
  const tableOptions = tableData?.columnName?.map((item: any) => ({
    key: item?.name,
    // header: item?.header ? item?.header : isEn ? item?.name_en : item?.name, // 为了兼容拖拉拽页面单表下载时, 不显示t0需求
    // header: ((isEn ? item?.name_en : item?.name) || item?.origin_name)?.replace(/(t[0-2]_)/, '') || '',
    header: (item?.name || item?.origin_name)?.replace(/(t[0-2]_)/, '') || '',
    type: item.column_date_type,
    accuracy: item.accuracy,
  }));
  const tableConfig = {
    option: tableOptions,
    downloadData: tableData?.data,
    isEn
  };
  handleDownload(tableConfig, name);
};

export default customDashboatdDownload;